<app-collapsible-container
    [id]="'role'"
    [title]="'REPERTOIRE.FORMS.ROLES.TITLE'"
    [icon]="'i-shield'"
    [maxSelection]="maxRolesNumber"
    [currentSelected]="mainRole.value && secondaryRole.value ? 2 : mainRole.value || secondaryRole.value ? 1 : 0"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ROLES.ROLE1-LABEL' | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'mainRole',
                choices: rolesChoices$ | async | filterRoleByEntity | removeParentRole
            }"
            [formControl]="mainRole"
            [isValid]="mainRole.valid"
            [placeholder]="'REPERTOIRE.FORMS.ROLES.ROLE-PLACEHOLDER'"
            [readOnly]="readonly"
        >
        </app-generic-select>
        <app-form-errors
            *ngIf="mainRole.touched"
            [errors]="mainRole.errors"
            (errorDisplay)="elementSizeModification.emit()"
        ></app-form-errors>
    </div>

    <div class="form-control">
        <div class="buttons-container">
            <label>{{ 'REPERTOIRE.FORMS.ROLES.ROLE2-LABEL' | translate }}</label>
            <span *ngIf="secondaryRole.value && !readonly" class="reset-role icon i-trash" (click)="resetRole()"></span>
        </div>
        <app-generic-select
            [config]="{
                formGroupName: 'secondaryRole',
                choices: rolesChoices$ | async | filterRoleByEntity: mainRole.value | removeParentRole
            }"
            [formControl]="secondaryRole"
            [isValid]="secondaryRole.valid"
            [placeholder]="'REPERTOIRE.FORMS.ROLES.ROLE-PLACEHOLDER'"
            [readOnly]="readonly"
        >
        </app-generic-select>
    </div>
</app-collapsible-container>
